import React, { useState } from 'react';
import styles from './InnField.module.scss';
import { Form, Input, Select } from 'antd';
import useOrgsByInn from '../../../../queries/useOrgsByInn';
import { filedNames } from '../../constants';
import { typeIds } from '../../../../constants/common';

const InnField = ({ form, initialValues }) => {
  const { getFieldDecorator, setFieldsValue, getFieldValue } = form;

  const [search, setSearch] = useState('');

  const { getAsync, isFetching, data: foundOrgs } = useOrgsByInn();

  let searchTimeoutId = null;

  const onSearchChange = (value) => {
    setSearch(value);

    clearTimeout(searchTimeoutId);

    searchTimeoutId = setTimeout(async () => {
      await getAsync(value);
    }, 200);
  };

  const options = foundOrgs?.map((org, index) => {
    return (
      <Select.Option
        key={org.inn}
        value={`${org.inn} ${index}`}
      >
        {org.inn}
        {org.inn && org.name && ' '}
        {org.name}
        {org.name && org.address && ' '}
        {org.address && `( ${org.address} )`}
      </Select.Option>
    );
  });

  const typeValue = getFieldValue(filedNames.typeId);

  if (typeValue !== typeIds.advertisement) return null;

  return (
    <div className={styles.root}>
      <Form.Item
        label="Поиск по названию, ИНН"
        validateStatus={search.length >= 300 ? 'warning' : ''}
        help={
          search.length >= 300 ? 'Вы достигли максимума в 300 символов' : ''
        }
      >
        <Select
          showSearch
          placeholder="Поиск организации по наименованию или ИНН:"
          onSearch={(search) => {
            if (search.length && search.length <= 300) {
              onSearchChange(search);
            }
          }}
          showArrow={false}
          filterOption={false}
          onChange={(key) => {
            const index = key.split(' ').pop();
            const selectedOrg = foundOrgs[index];

            setFieldsValue({
              inn: selectedOrg.inn,
              name: selectedOrg.name,
            });
          }}
          defaultActiveFirstOption={false}
          loading={isFetching}
          notFoundContent={
            search && !isFetching && 'Не найдены подходящие компании'
          }
        >
          {options}
        </Select>
      </Form.Item>
      <div className={styles.row}>
        <Form.Item
          label="ИНН:"
          style={{ width: '100%' }}
        >
          {getFieldDecorator('inn', {
            initialValue: initialValues?.inn || '',
            rules: [
              { required: true, min: 10, message: 'Пожалуйста укажите ИНН' },
            ],
          })(<Input disabled={true} />)}
        </Form.Item>

        <Form.Item
          label="Наименование:"
          style={{ width: '100%' }}
        >
          {getFieldDecorator('name', {
            initialValue: initialValues?.name || '',
            rules: [
              {
                required: true,
                min: 3,
                message: 'Пожалуйста укажите наименование организации',
              },
            ],
          })(<Input disabled={true} />)}
        </Form.Item>
      </div>
      <Form.Item label="ЕРИД:">
        {getFieldDecorator('erid', {
          initialValue: initialValues?.erid || '',
          rules: [
            {
              required: true,
              message: 'Пожалуйста укажите ЕРИД',
            },
            { max: 50, message: 'ЕРИД может содержать максимум 50 символов' },
          ],
        })(<Input />)}
      </Form.Item>
    </div>
  );
};

export default InnField;
